export default __webpack_public_path__ + "10807879b98006da1b0f43a261b98d34.svg";